import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["indicator", "content"]
  static values = {
    loadingUrl: String
  }
  
  connect() {
    // Hide the loading indicator initially
    if (this.hasIndicatorTarget) {
      this.hideIndicator()
      
      // Don't automatically show indicator for all navigation
      // Only show for copy-to-all operations
      document.addEventListener('turbo:before-fetch-response', this.hideIndicator.bind(this))
      document.addEventListener('turbo:submit-end', this.hideIndicator.bind(this))
      
      // Also hide on page unload to prevent stuck overlays
      window.addEventListener('beforeunload', this.hideIndicator.bind(this))
      
      // Only show loading indicator for specific operations (copy-to-all)
      const copyButtons = document.querySelectorAll('.copy-to-all-btn')
      copyButtons.forEach(button => {
        button.addEventListener('click', this.showIndicator.bind(this))
      })
    }
  }
  
  disconnect() {
    // Clean up event listeners
    document.removeEventListener('turbo:before-fetch-response', this.hideIndicator.bind(this))
    document.removeEventListener('turbo:submit-end', this.hideIndicator.bind(this))
    window.removeEventListener('beforeunload', this.hideIndicator.bind(this))
    
    // Clean up copy button listeners
    const copyButtons = document.querySelectorAll('.copy-to-all-btn')
    copyButtons.forEach(button => {
      button.removeEventListener('click', this.showIndicator.bind(this))
    })
  }
  
  showIndicator(event) {
    // Show the local indicator
    if (this.hasIndicatorTarget) {
      this.indicatorTarget.classList.remove('hidden')
      if (this.hasContentTarget) {
        this.contentTarget.classList.add('opacity-25')
      }
      
      // Only show the copy overlay for copy operations
      // This prevents the overlay from showing for regular navigation
      if (event && event.currentTarget && event.currentTarget.classList.contains('copy-to-all-btn')) {
        // Show the global page overlay for copy operations
        const pageOverlay = document.getElementById('page-overlay')
        if (pageOverlay) {
          pageOverlay.classList.remove('hidden')
          
          // Disable the button to prevent double-clicks
          if (event.currentTarget) {
            event.currentTarget.classList.add('pointer-events-none', 'opacity-50')
          }
        }
      } else {
        // For all other cases, ensure the global overlay stays hidden
        const pageOverlay = document.getElementById('page-overlay')
        if (pageOverlay) {
          pageOverlay.classList.add('hidden')
        }
      }
    }
  }
  
  hideIndicator() {
    // Hide the local indicator
    if (this.hasIndicatorTarget) {
      this.indicatorTarget.classList.add('hidden')
      if (this.hasContentTarget) {
        this.contentTarget.classList.remove('opacity-25')
      }
      
      // Also hide the global page overlay
      const pageOverlay = document.getElementById('page-overlay')
      if (pageOverlay) {
        pageOverlay.classList.add('hidden')
        
        // Re-enable any disabled copy buttons
        document.querySelectorAll('.copy-to-all-btn.pointer-events-none').forEach(btn => {
          btn.classList.remove('pointer-events-none', 'opacity-50')
        })
      }
    }
  }
  
  redirectToLoadingPage(event) {
    // Don't prevent the form submission, but navigate to the loading page
    if (this.hasLoadingUrlValue) {
      // Set a flag in session storage that we're submitting the form
      sessionStorage.setItem('schedulePending', 'true')
      
      // Navigate to the loading page
      window.location.href = this.loadingUrlValue
      
      // Return false to prevent the default form submission
      // The form will be submitted via regular POST in the background
      return false
    }
  }
}